import { Bulletin } from '@/types/residents/bulletin';

export const getBulletinDescription = (b: Bulletin): string => {
  return (b.description || b.responseDescription || '').trim();
};

export const formatResidentBulletinDate = (date: Date | string | null | undefined): string => {
  if (!date) return 'No Details Found';
  const d = typeof date === 'string' ? new Date(date) : date;
  return d.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
};


